import {
  ACCUSATIONS,
  CONSEQUENCES,
  examRules,
  FAQS,
  Procedures,
  Vacancies,
} from "../../fixtures";
import { useState } from "react";
import examSchedule from "../../images/ExamSchedule.png";
import hrwoExamSchedule from "../../images/Exam_Date_of_HRWO.png";
import dwoAwoExamSchedule from "../../images/Exam_Date_of_DWO_and_AWO.png";
import rwoItwoHrwoResult from "../../images/rwo_itwo_hrwo_result.png";
import dwoResult1 from "../../images/dwo_result1.png";
import dwoResult2 from "../../images/dwo_result2.png";
import awoResult from "../../images/awo_result.png";
import waitingList1 from "../../images/waitingList1.png";
import waitingList2 from "../../images/waitingList2.png";
import waitingList3 from "../../images/waitingList3.png";
import waitingList4 from "../../images/waitingList4.png";
import int_rwo_hrwo from "../../images/Interview_RWO_&_HRWO.png";
import int_itwo from "../../images/Interview_ITWO.png";
import int_awo from "../../images/Interview_AWO.png";
import int_dwo_1 from "../../images/Interview_DWO_1.png";
import int_dwo_2 from "../../images/Interview_DWO_2.png";
import wl_dwo_1 from "../../images/DWOWL_1.png";
import wl_dwo_2 from "../../images/DWOWL_2.png";
import wl_dwo_3 from "../../images/DWOWL_3.png";
import wl_dwo_4 from "../../images/DWOWL_4.png";
import wl_dwo_5 from "../../images/DWOWL_5.png";
import wl_awo_1 from "../../images/AWOWL_1.png";
import wl_awo_2 from "../../images/AWOWL_2.png";
import wl_awo_3 from "../../images/AWOWL_3.png";
import vrrwohrwo from "../../images/vrRWO&HRWO.png";
import vrawo1 from "../../images/vrAWO(Sheet1).png";
import vrawo2 from "../../images/vrAWO(Sheet2).png";
import vrdwo1 from "../../images/vrDWO(Sheet1).png";
import vrdwo2 from "../../images/vrDWO(Sheet2).png";
import vrdwo3 from "../../images/vrDWO(Sheet3).png";
import vrdwo4 from "../../images/vrDWO(Sheet4).png";
import vrdwo5 from "../../images/vrDWO(Sheet5).png";
import vritwo from "../../images/vrITWO.png";
import mornigSchedule from '../../images/MORNING_ROUTINE.png';
import eveningSchedule from '../../images/EVENING_ROUTINE.png';
import { ChevronLeft } from "lucide-react";

export const Brt2024 = () => {
  const VacantList = () => {
    const vacancies = Vacancies();
    const [selectedIdx, setSelectedIdx] = useState<number | null>(null);

    const handleCheckboxChange = (index: number) => {
      setSelectedIdx(index === selectedIdx ? null : index);
    };

    return (
      <>
      <div className=" w-[100%] mt-[-44px] flex justify-end  md:flex justify-end mx-auto">
        <button
          className="text-md bg-sky-300 rounded-xl px-3 py-2 flex gap-1"
          onClick={() => (window.location.href = "/")}
        >
          <ChevronLeft/>
          Back
        </button>
      </div>

      {/* <div className="py-3 w-[90%] flex justify-end md:flex md:justify-end mx-auto ">
        <button
          className="text-md bg-sky-300 rounded-xl px-3 py-2 flex gap-1"
          onClick={() => (window.location.href = "/")}
        >
          <ChevronLeft />
          Back
        </button>
      </div> */}


         <div className="max-w-fit mx-auto text-white bg-[#08ACF2] hover:bg-[hsl(198,94%,39%)] p-2 border border-blue-700 rounded-md text-sm md:text-xl mt-[40px]">
            <a
              href="https://nhwm.in/signup"
              target="_blank"
              rel="noopener noreferrer"
            >
              &#10153;  Click here to apply for BRT 2025-2026
            </a>
          </div>
       

          <p className="justify-self-start text-md md:text-xl lg:text-2xl text-gray-600 font-extrabold mt-[50px]">
          Click any heading below to learn more :-
        </p>
        {/* {vacancies.map((item: any, index: number) => (
          <div
            key={index}
            tabIndex={0}
            className={`collapse collapse-plus border border-base-300 bg-base-200 mt-4 ${
              index === selectedIdx ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={index === selectedIdx}
              onChange={() => handleCheckboxChange(index)}
            />

            <div className="collapse-title text-lg font-bold md:text-xl bg-slate-300">
              {item.title}
            </div>
            <div className="collapse-content">
              <b>Qualification :-</b>
              <p>{item.qualifications}</p>
              <br />
              <b>Preference (Not mandatory)</b>
              <p>{item.preference}</p>
              <br />
              <b>Service Type :-</b>
              <p>{item.serviceType}</p>
              <br />
              <b>Salary :-</b>
              <p>{item.salary}</p>
              <br />
              <b>Promotion :-</b>
              <p>{item.promotion}</p>
              <br />
              <b>Pension Scheme :-</b>
              <p>{item.pensionScheme}</p>
              <br />
              <b>Mediclaim Facility :-</b>
              <p>{item.mediclaimFacility}</p>
              <br />
              <b>Group Term Insurance :-</b>
              <p>{item.groupTermInsurance}</p>
              <br />
              <b>Age Limit :-</b>
              <p>{item.ageLimit}</p>
              <br />
              <b>Language :-</b>
              <p>{item.language}</p>
              <br />
              <b>Job Responsibility :-</b>
              <p>{item.jobResponsibility}</p>
              <br />
              <b>Reporting :-</b>
              <p>{item.reporting}</p>
            </div>
          </div>
        ))} */}
      </>
    );
  };

  const ProcedureList: React.FC = () => {
    const [selectedIdx, setSelectedIdx] = useState<number | null>(null);

    const handleCheckboxChange = (index: number) => {
      setSelectedIdx(index === selectedIdx ? null : index);
    };

    return (
      <div>
        {Procedures.map((item: any, index: number) => (
          <div
            key={index}
            tabIndex={0}
            className={`collapse collapse-plus border border-base-300 bg-base-200 mt-4 ${
              index === selectedIdx ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={index === selectedIdx}
              onChange={() => handleCheckboxChange(index)}
            />
            <div className="collapse-title text-lg font-bold md:text-xl bg-slate-300">
              {item.title}
            </div>
            <div className="collapse-content">
              <ul>
                {item.descriptionList.map((description: string, i: any) => (
                  <div key={i}>
                    {i === 23 ? (
                      <>
                        <li>
                          &bull; A candidate who is or has been declared by the
                          Board to be guilty of:
                        </li>
                        <ol>
                          {/* List out accusations */}
                          {ACCUSATIONS.map((accusation: any, index: number) => (
                            <li key={index}>
                              {index + 1}. {accusation}
                            </li>
                          ))}
                        </ol>
                        <br />
                        <li>- may be liable:</li>
                        <br />
                        <ol>
                          {/* List out consequences */}
                          {CONSEQUENCES.map((consequence: any, index: number) => (
                            <li key={index}>
                              {index + 1}. {consequence}
                            </li>
                          ))}
                        </ol>
                      </>
                    ) : (
                      <li>&bull; {description}</li>
                    )}
                    <br />
                  </div>
                ))}
              </ul>
              {/* Centered text at the bottom */}
              {index === Procedures.length - 1 && (
                <div className="text-center font-bold mt-4">
                  By order of the Mission Directors, NHWM
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // const FAQList = () => {
  //   return (
  //     <div
  //       tabIndex={0}
  //       className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
  //     >
  //       <input type="checkbox" />
  //       <div className="collapse-title text-lg font-bold md:text-xl bg-slate-300">
  //         FAQs for NHWM Job Advertisement
  //       </div>
  //       <div className="collapse-content">
  //         {FAQS.map((faq: any, index: number, array: any) => (
  //           <div key={faq.question}>
  //             <p>
  //               <b>Q :-</b> {faq.question}
  //             </p>
  //             <p>
  //               <b>A :-</b>
  //               {index === 0 ? (
  //                 <>
  //                   {faq.answer}
  //                   <a
  //                     className="text-[#08ACF2] font-bold"
  //                     href="/intimation-letters"
  //                     target="_blank"
  //                   >
  //                     {" "}
  //                     Click here to see the letters.
  //                   </a>
  //                 </>
  //               ) : (
  //                 <>{faq.answer}</>
  //               )}
  //             </p>
  //             <br />
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   );
  // };
  const Syllabus = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
      >
        <input type="checkbox" />
        <div className="collapse-title text-lg font-bold md:text-xl bg-slate-300">
          OUTLINED SYLLABUS FOR BRT, 2023-2024
        </div>
        <div className="collapse-content">
          <h1 className="text-md font-bold mb-2 mt-4">
            For DWO candidates:- Total Marks: 100
          </h1>
          <h3 className="text-md font-medium my-2">
            Part 1 – General Knowledge (20 Marks)
          </h3>
          <ul className="list-disc ml-4">
            <li>Indian History</li>
            <li>Indian Economy</li>
            <li>Indian Geography</li>
            <li>Indian Politics</li>
          </ul>
          <h3 className="text-md font-medium my-2">
            Part 2 – Special Paper (80 Marks)
          </h3>
          <h3 className="text-md font-medium my-2">For DWO-</h3>
          <ul className="list-disc ml-4">
            <li>IX & X standard General Science</li>
            <li>Principles of Human Nutrition</li>
          </ul>
          <h3 className="text-md font-medium my-2">For AWO -</h3>
          <ul className="list-disc ml-4">
            <li>VIII & IX Standard General Science</li>
            <li>Basics of Human Nutrition</li>
          </ul>
          <h1 className="text-md font-bold mb-2 mt-4">
            For RWO candidates:- Total 100 Marks
          </h1>
          <h3 className="text-md font-medium my-2">
            Part 1 – General Knowledge (20 Marks)
          </h3>
          <ul className="list-disc ml-4">
            <li>Indian History</li>
            <li>Indian Economy</li>
            <li>Indian Geography</li>
            <li>Indian Politics</li>
          </ul>
          <h3 className="text-md font-medium my-2">
            Part 2 – Special Paper (80 Marks)
          </h3>
          <ul className="list-disc ml-4">
            <li>Basics of Human Anatomy</li>
            <li>Basics of human Physiology</li>
            <li>Basics of Food & Nutritional Biochemistry</li>
            <li>Basics of Environmental Science</li>
            <li>Basics of Computer Application</li>
            <li>Basics of Leadership & Team Management</li>
          </ul>
        </div>
  
      </div>
    );
  };

  const ExamPattern = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
      >
        <input type="checkbox" />
        <div className="collapse-title text-lg font-bold md:text-xl bg-slate-300">
          EXAM PATTERNS, (BRT 2023-2024)
        </div>
        <div className="collapse-content text-lg">
          <p className="font-bold text-xl my-2">
            Exam will be in <span className="text-xl italic">TWO SECTIONS</span>
            {" "}for RWO (no break/gap will be there in between the
            sections)
          </p>
          <p className="font-bold ml-4">Section 1 :- Duration 30 minutes</p>
          <p>
            <span className="font-bold ml-8">Only MCQ</span> from both the parts
            of the Syllabus ( 10 Questions from Part -1, 30 Questions from Part
            - 2)
          </p>
          <p className="font-bold mt-3 ml-4">Section 2:- Duration 60 minutes</p>
          <p>
            <span className="font-bold ml-8">Short Questions</span> from both
            the parts of the Syllabus ( 5 Questions from Part - 1, 10 Questions
            from Part - 2 )
          </p>
          <p>
            <span className="font-bold ml-8">Long Questions</span> only from
            Part - 2 of the Syllabus (6 Questions)
          </p>
          <p className="font-bold text-xl my-4 ">
            DWO Exam will be in ONE SECTIONS only with 100 MCQs, 20 MCQs
            from Part 1 and 80 MCQs from Part 2 Books
          </p>
          <p className="font-bold text-xl mb-4 mt-8 uppercase">Mode of Exam is Online</p>
          <p className="font-bold my-2">Rules of Exam :-</p>
          <ul className="list-disc mx-3 text-xl font-bold leading-7 ml-8">
            {
              examRules.map((rule: any, index: number) => (
                <li className="my-1" key={index}>{rule}</li>
              ))
            }
          </ul>
        </div>
      </div>
    );
  };

  const ImportantDates = () => {
    return (
    <>      
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
      >
        <input type="checkbox" /> 
        <div className="collapse-title text-xl font-bold bg-slate-300">
          IMPORTANT INFORMATIONS REGARDING BRT, 2023-2024
        </div>
        <div className="collapse-content flex flex-col gap-3 md:text-lg">
          {/* <div className="flex gap-2 justify-center items-center">
            <span className="motion-safe:animate-pulse animate-blink transition-all delay-1000">
              <svg
                className="text-red-500 bg-red-500 rounded-full"
                width="36px"
                height="36px"
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>new-star-solid</title>
                <g id="Layer_2" data-name="Layer 2">
                  <g id="invisible_box" data-name="invisible box">
                    <rect width="48" height="48" fill="none" />
                  </g>
                  <g id="Q3_icons" data-name="Q3 icons">
                    <path d="M42.3,24l3.4-5.1a2,2,0,0,0,.2-1.7A1.8,1.8,0,0,0,44.7,16l-5.9-2.4-.5-5.9a2.1,2.1,0,0,0-.7-1.5,2,2,0,0,0-1.7-.3L29.6,7.2,25.5,2.6a2.2,2.2,0,0,0-3,0L18.4,7.2,12.1,5.9a2,2,0,0,0-1.7.3,2.1,2.1,0,0,0-.7,1.5l-.5,5.9L3.3,16a1.8,1.8,0,0,0-1.2,1.2,2,2,0,0,0,.2,1.7L5.7,24,2.3,29.1a2,2,0,0,0,1,2.9l5.9,2.4.5,5.9a2.1,2.1,0,0,0,.7,1.5,2,2,0,0,0,1.7.3l6.3-1.3,4.1,4.5a2,2,0,0,0,3,0l4.1-4.5,6.3,1.3a2,2,0,0,0,1.7-.3,2.1,2.1,0,0,0,.7-1.5l.5-5.9L44.7,32a2,2,0,0,0,1-2.9ZM18,31.1l-4.2-3.2L12.7,27h-.1l.6,1.4,1.7,4-2.1.8L9.3,24.6l2.1-.8L15.7,27l1.1.9h0a11.8,11.8,0,0,0-.6-1.3l-1.6-4.1,2.1-.9,3.5,8.6Zm3.3-1.3-3.5-8.7,6.6-2.6.7,1.8L20.7,22l.6,1.6L25.1,22l.7,1.7L22,25.2l.7,1.9,4.5-1.8.7,1.8Zm13.9-5.7-2.6-3.7-.9-1.5h-.1a14.7,14.7,0,0,1,.4,1.7l.8,4.5-2.1.9-5.9-7.7,2.2-.9,2.3,3.3,1.3,2h0a22.4,22.4,0,0,1-.4-2.3l-.7-4,2-.8L33.8,19,35,20.9h0s-.2-1.4-.4-2.4L34,14.6l2.1-.9,1.2,9.6Z" />
                  </g>
                </g>
              </svg>
            </span>
            <h3 className="text-xl font-semibold text-red-500 text-center my-3">
              Results of BRT have been declared. Please scroll down to the Result
              Section for checking your Result.
            </h3>
          </div> */}
          {/* <div className="p-3 bg-slate-200 flex-col flex rounded-md gap-y-3 mb-3 mt-10">
            <span className="text-black font-bold uppercase">
              Login Credentials :–
            </span>
          </div> */}

          <div className="flex-col">
            {/* <span className="ml-4 font-bold">RWO</span>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Assam and Northeast States - `}
              <b>Already shared through Email</b>
            </li>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Rest of the States of India - `}
              <b>Already shared through Email</b>
            </li>
          </div>
          <div className="flex-col">
            <span className="ml-4 font-bold">ITWO & HRWO</span>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Assam and Northeast States - `}
              <b>Already shared through Email</b>
            </li>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Rest of the States of India -  `}
              <b>Already shared through Email</b>
            </li> */}
          </div>
          {/* DWO & AWO */}
          {/* <div className="flex-col">
            <span className="ml-4 font-bold">DWO & AWO</span>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Assam and Northeast States - `}
              <b>Already shared through Email</b>
            </li>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Rest of the States of India -  `}
              <b>Already shared through Email</b>
            </li>
          </div> */}
          {/* <div className="flex justify-center flex-col">
            <p className="text-lg text-center font-bold italic">
              Candidates are requested to check their mails for Login
              Credentials
            </p>
            <p className="text-md text-center font-semibold italic">
              Please search in the Email Search bar as NHWM
            </p>
          </div> */}
          {/* <div className="p-3 bg-slate-200 flex-col flex rounded-md gap-y-3 mb-3 mt-10">
            <span className="text-black font-bold uppercase">
              Access to the Exam Portal :–
            </span>
          </div> */}

          {/* <div className="flex-col">
            <span className="ml-4 font-bold">RWO, ITWO & HRWO</span>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Assam and Northeast States - `}
              <b>Access Approved</b>
            </li>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Rest of the States of India - `}
              <b>Access Approved</b>
            </li>
          </div> */}
          {/* DWO & AWO */}
          {/* <div className="flex-col">
            <span className="ml-4 font-bold">DWO & AWO</span>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Assam and Northeast States - `}
              <b>Access Approved</b>
            </li>
            <li className="md:ml-8 text-[13px] md:text-base">
              {`Rest of the States of India -  `}
              <b>Access Approved</b>
            </li>
          </div> */}
          {/* section */}
          <div className="p-3 bg-slate-200 flex-col flex rounded-md gap-y-3 mb-3 mt-10">
            <span className="text-black font-bold uppercase">
              dates of Basic Recruitment Test :–
            </span>
          </div>

          {/* RWO, ITWO & HRWO */}
          <div className="flex flex-col font-bold gap-y-3">
            <div>
              <p className="ml-4">RWO</p>
              <ul className="list-disc ml-12">
                <li>
                  Assam - 14th, 17th, 22nd and 26th ( 2 batches clubbed )
                  September 2024
                </li>
                <li>NE states - 30th September & 1st October 2024</li>
              </ul>
              <h1 className="underline mt-3 ml-4 text-center text-xl">
                RWO Rest of the States of India and ITWO-
              </h1>
              <img
                src={examSchedule}
                alt="exam schedule"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <h1 className="mt-3 ml-4 text-center text-xl underline">
                HRWO EXAM SCHEDULE FOR ALL INDIA
              </h1>
              <img
                src={hrwoExamSchedule}
                alt="HRWO exam schedule"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <h1 className="mt-3 underline ml-4 text-center text-xl">
                DWO & AWO EXAM SCHEDULE FOR ALL INDIA
              </h1>
              <img
                src={dwoAwoExamSchedule}
                alt="DWO & AWO exam schedule"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
            </div>
            <p className="text-center mt-4">
              We send Email for guiding candidates - how to schedule the Exam
              Slot/s. Candidates are requested to check their email time to time
              in the registered email id.
            </p>
          </div>
        </div>
      </div>
      </>
    );
  };

  const BRTResult = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
        id="result"
      >
        <input type="checkbox" />
        <div className="collapse-title text-xl font-bold bg-slate-300">
          BRT RESULT, (BRT 2023-2024)
        </div>
        <div className="collapse-content flex flex-col gap-3 md:text-lg">
          <div className="">
            <div className="mx-auto">
              <img
                src={rwoItwoHrwoResult}
                alt="qualified candidates"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={dwoResult1}
                alt="qualified candidates"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={dwoResult2}
                alt="qualified candidates"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={awoResult}
                alt="qualified candidates"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
            </div>
            <div className="mt-4 border-t-2 border-gray-400">
              <h3 className="text-2xl font-bold text-center mt-3">
                Waiting List of Candidates
              </h3>
              <div>
                <img
                  src={waitingList1}
                  alt="waiting list candidates"
                  className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
                />
                <img
                  src={waitingList2}
                  alt="waiting list candidates"
                  className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
                />
                <img
                  src={waitingList3}
                  alt="waiting list candidates"
                  className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
                />
                <img
                  src={waitingList4}
                  alt="waiting list candidates"
                  className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const VivaDate = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
      >
        <input type="checkbox" />
        <div className="collapse-title text-xl font-bold bg-slate-300">
          DATE OF VIVA FOR THE SELECTED CANDIDATES, (BRT 2023-2024)
        </div>
        <div className="collapse-content flex flex-col gap-3 md:text-lg">
          <div>
            <div>
              <h1 className="text-2xl font-bold text-center my-4 text-sky-500">
                INTERVIEW DATES
              </h1>
              <img
                src={int_rwo_hrwo}
                alt="interview rwo & hrwo"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={int_itwo}
                alt="interview itwo"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={int_awo}
                alt="interview awo"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={int_dwo_1}
                alt="interview dwo"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={int_dwo_2}
                alt="interview dwo"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
            </div>
            <div className="border-t border-gray-400 mt-24">
              <h1 className="text-2xl font-bold text-center my-4 text-sky-500">
                WAIT LISTED CANDIDATES
              </h1>
              <img
                src={wl_dwo_1}
                alt="waiting list dwo 1"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={wl_dwo_2}
                alt="waiting list dwo 2"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={wl_dwo_3}
                alt="waiting list dwo 3"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={wl_dwo_4}
                alt="waiting list dwo 4"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={wl_dwo_5}
                alt="waiting list dwo 5"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={wl_awo_1}
                alt="waiting list awo 1"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={wl_awo_2}
                alt="waiting list awo 2"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={wl_awo_3}
                alt="waiting list awo 3"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const VivaResult = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
        id="viva"
      >
        <input type="checkbox" />
        <div className="collapse-title text-xl font-bold bg-slate-300">
          VIVA RESULT, (BRT 2023-2024)
        </div>
        <div className="collapse-content flex flex-col gap-3 md:text-lg">
          <div>
            <div>
              <img
                src={vrrwohrwo}
                alt="viva result rwo & hrwo"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={vritwo}
                alt="viva result rwo & hrwo"
                className="max-w-full md:max-w-[1080px] mx-auto my-8"
              />
              <img
                src={vrdwo1}
                alt="viva result dwo sheet 1"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={vrdwo2}
                alt="viva result dwo sheet 2"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={vrdwo3}
                alt="viva result dwo sheet 3"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={vrdwo4}
                alt="viva result dwo sheet 4"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={vrdwo5}
                alt="viva result dwo sheet 5"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={vrawo1}
                alt="viva result awo sheet 1"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
              <img
                src={vrawo2}
                alt="viva result awo sheet 2"
                className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const StartOfTraining = () => {
    return (
      <div
        tabIndex={0}
        className="collapse collapse-plus border border-base-300 bg-base-200 mt-4"
        id="schedule"
      >
        <input type="checkbox" defaultChecked />
        <div className="collapse-title text-xl font-bold bg-slate-300">
          TRAINING SCHEDULE FOR THE SELECTED CANDIDATES, (BRT 2023-2024)
        </div>
        <div className="collapse-content flex flex-col gap-3 md:text-lg">
          <div>
            <img
              src={mornigSchedule}
              alt="morning schedule"
              className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
            />
            <img
              src={eveningSchedule}
              alt="evening schedule"
              className="max-w-full md:max-w-[1080px] mx-auto my-8 aspect-[3/4]"
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="flex justify-center items-center flex-col gap-4 pl-5 pr-5 pb-5 navbar-offset">
        <div>
          {/* <div className="flex gap-2 justify-center items-center">
            <span className="motion-safe:animate-pulse animate-blink transition-all delay-1000">
              <svg
                className="text-red-500 bg-red-500 rounded-full"
                width="36px"
                height="36px"
                viewBox="0 0 48 48"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>new-star-solid</title>
                <g id="Layer_2" data-name="Layer 2">
                  <g id="invisible_box" data-name="invisible box">
                    <rect width="48" height="48" fill="none" />
                  </g>
                  <g id="Q3_icons" data-name="Q3 icons">
                    <path d="M42.3,24l3.4-5.1a2,2,0,0,0,.2-1.7A1.8,1.8,0,0,0,44.7,16l-5.9-2.4-.5-5.9a2.1,2.1,0,0,0-.7-1.5,2,2,0,0,0-1.7-.3L29.6,7.2,25.5,2.6a2.2,2.2,0,0,0-3,0L18.4,7.2,12.1,5.9a2,2,0,0,0-1.7.3,2.1,2.1,0,0,0-.7,1.5l-.5,5.9L3.3,16a1.8,1.8,0,0,0-1.2,1.2,2,2,0,0,0,.2,1.7L5.7,24,2.3,29.1a2,2,0,0,0,1,2.9l5.9,2.4.5,5.9a2.1,2.1,0,0,0,.7,1.5,2,2,0,0,0,1.7.3l6.3-1.3,4.1,4.5a2,2,0,0,0,3,0l4.1-4.5,6.3,1.3a2,2,0,0,0,1.7-.3,2.1,2.1,0,0,0,.7-1.5l.5-5.9L44.7,32a2,2,0,0,0,1-2.9ZM18,31.1l-4.2-3.2L12.7,27h-.1l.6,1.4,1.7,4-2.1.8L9.3,24.6l2.1-.8L15.7,27l1.1.9h0a11.8,11.8,0,0,0-.6-1.3l-1.6-4.1,2.1-.9,3.5,8.6Zm3.3-1.3-3.5-8.7,6.6-2.6.7,1.8L20.7,22l.6,1.6L25.1,22l.7,1.7L22,25.2l.7,1.9,4.5-1.8.7,1.8Zm13.9-5.7-2.6-3.7-.9-1.5h-.1a14.7,14.7,0,0,1,.4,1.7l.8,4.5-2.1.9-5.9-7.7,2.2-.9,2.3,3.3,1.3,2h0a22.4,22.4,0,0,1-.4-2.3l-.7-4,2-.8L33.8,19,35,20.9h0s-.2-1.4-.4-2.4L34,14.6l2.1-.9,1.2,9.6Z" />
                  </g>
                </g>
              </svg>
            </span>
            <h3 className="text-xl font-semibold text-red-500 text-center my-3">
              <a href="#schedule">
                Training for the selected candidates of the BRT 2023–24 batch is currently in progress. Click here to view the schedule.
              </a>
            </h3>
          </div> */}
          {/* <div>
            <h3 className="text-2xl font-semibold text-red-500 text-center my-3">
              <a href="/training-registration">
                If you have qualified in VIVA, Click Here to Register in
                Training.
              </a>
            </h3>
          </div> */}
           <div className="mt-10 mb-5">
            {/* <p className="text-base md:text-4xl text-center font-extrabold text-gray-600 mt-10">
              Application submission process is over for<br/> Basic Recruitment Test
              2023-24
              to fill-up the following post in <br /> National Healthcare and
              Wellness Mission (NHWM)
            </p> */}
          </div>
          {/* <p className="text-lg md:text-2xl text-gray-600 text-center mt-5 mb-5">
            Total Number of Vacant Posts - 3200 and will be filled state-wise
            gradually
          </p> */}
        </div> 
        <div className="container">{VacantList()}</div>
        <div className="container">
  
          <ImportantDates />
          <BRTResult />
          <VivaDate />
          <VivaResult />
          <StartOfTraining />
        </div>

 
      <div className="max-w-fit mx-auto text-white bg-[#08ACF2] hover:bg-[hsl(198,94%,39%)] p-2 border border-blue-700 rounded-md text-sm md:text-xl">
            <a
              href="https://nhwm.in/signup"
              target="_blank"
              rel="noopener noreferrer"
            >
              &#10153; Apply for BRT 2025-2026
            </a>
          </div>


        
      </div>
      </div>
  );
};
